import { useState, useEffect } from "react";
import { FaTrash, FaCheck } from "react-icons/fa";
import "./AdminReviewPage.css";

export default function AdminReviewPage() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const response = await fetch("https://back.varankal.com/api/reviews");
      if (!response.ok) throw new Error("Failed to fetch reviews");
      const data = await response.json();
      setReviews(data);
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      const response = await fetch(`https://back.varankal.com/api/reviews/${id}/approve`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to approve review");
      }

      fetchReviews();
    } catch (error) {
      console.error("Error approving review:", error);
      setError(error.message);
    }
  };



  const handleDelete = async (id) => {
    try {
      const response = await fetch(
        `https://back.varankal.com/api/reviews/${id}`,
        {
          method: "DELETE",
        }
      );
      if (!response.ok) throw new Error("Failed to delete review");
      fetchReviews();
    } catch (error) {
      console.error("Error deleting review:", error);
      setError(error.message);
    }
  };

  return (
    <section className="admin-review-pageW99">
      <h2 className="section-titleW99">Admin Review Management</h2>
      {loading ? (
        <p>Loading reviews...</p>
      ) : error ? (
        <p className="error-messageW99">{error}</p>
      ) : reviews.length === 0 ? (
        <p>No reviews available.</p>
      ) : (
        <table className="review-tableW99">
          <thead>
            <tr>
              <th>User</th>
              <th>Review</th>
              <th>Rating</th>
              <th>Approved</th> {/* New column */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((review) => (
              <tr key={review._id}>
                <td>{review.user}</td>
                <td>{review.review}</td>
                <td>{"⭐".repeat(review.rating)}</td>
                <td>{review.isApproved ? "✅ Approved" : "❌ Pending"}</td> {/* Show status */}
                <td>
                  {!review.isApproved && (
                    <button className="approve-buttonW99" onClick={() => handleApprove(review._id)}>
                      <FaCheck /> Approve
                    </button>
                  )}
                  <button className="delete-buttonW99" onClick={() => handleDelete(review._id)}>
                    <FaTrash /> Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}